module.exports = __webpack_public_path__ + "img/-LV56ziIjVjjsdiUFI4c.1e686b50.jpg";